import React, { useState, Fragment } from "react";
import { Menu, Transition, Listbox } from "@headlessui/react";
import { ChevronDownIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import erc20List from "../../utils/erc20List";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const DropdownCurrency = ({
  isTime,
  isFrequency,
  frequency,
  className,
  date,
  onClick,
}) => {
  const [selected, setSelected] = useState(undefined);
  let fillClasses = "";
  let activeClasses;
  let activeOptions;

  activeClasses = (
    <>
      {" "}
      <Listbox.Button
        className={`${className} inline-flex  h-14 place-items-center place-content-center rounded-xl  bg-white px-4 py-2 text-sm font-medium text-gray-700  hover:bg-gray-50 focus:outline-none`}
      >
        <span className="block truncate">
          {selected ? selected : "Currency Options"}
        </span>
        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
          <ChevronUpDownIcon
            className="h-5 w-5 text-gray-400"
            aria-hidden="true"
          />
        </span>
      </Listbox.Button>
    </>
  );
  window.debugContext = { erc20List };
  const sortedOptions = erc20List.trustwallet.tokens.sort((a, b) =>
    a.name.localeCompare(b.name)
  );
  activeOptions = sortedOptions.map((token, tokenIndex) => (
    <Listbox.Option
      key={tokenIndex}
      data-currency={token.symbol}
      className={({ active }) =>
        classNames(
          "inline-flex w-full ",
          active ? "bg-gray-100 text-gray-900" : "text-gray-700",
          "block px-4 py-2 text-sm"
        )
      }
      value={token.symbol}
    >
      {({ selected, active }) => (
        <>
          <button
            type="button"
            className={classNames(
              "inline-flex w-full",
              selected ? "bg-gray-100 text-gray-900" : "text-gray-700",
              "block px-4 py-2 text-sm"
            )}
            onClick={() => onClick(token)}
          >
            <img
              className="mr-2 h-6 w-6"
              aria-hidden="true"
              src={token.logoURI}
            />
            {date ? (
              "Choose"
            ) : (
              <h6 className="font-bold text-md ml-5 my-auto">{token.symbol}</h6>
            )}
          </button>
        </>
      )}
    </Listbox.Option>
  ));
  window.debugContext.items = activeOptions;
  return (
    <Listbox
      as="div"
      className={`relative inline-block text-left ${fillClasses}`}
      value={selected}
      onChange={setSelected}
    >
      {({ open }) => (
        <>
          <div className="relative mt-1">
            {activeClasses}

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute right-0 z-10 mt-2 w-52 max-h-96 overflow-auto origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                {activeOptions}
              </Listbox.Options>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
  );
};
export default DropdownCurrency;
